;(function ($) {


    var container = $('body'),
        bar = $('.sfx-scrollbar'),
        scroll = 0,
        maxScroll = 99999

    function update() {
        scroll = $(window).scrollTop()
        var progress = (scroll / maxScroll) * 100 + '%'
        bar.css('width', progress)
    }

    function init() {
        let heightViewport = document.documentElement.clientHeight,
            heightPage = container[0].scrollHeight

        maxScroll = heightPage - heightViewport
        update()
    }

    init()
    $(window).scroll(update)
    $(window).resize(init)


})(jQuery);
